import { render, staticRenderFns } from "./Sepet.vue?vue&type=template&id=56a33402&scoped=true&"
import script from "./Sepet.vue?vue&type=script&lang=js&"
export * from "./Sepet.vue?vue&type=script&lang=js&"
import style0 from "./Sepet.vue?vue&type=style&index=0&id=56a33402&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a33402",
  null
  
)

export default component.exports